module.exports = __webpack_public_path__ + "static/assets/c0480e8492ad09fbf799c038cbd148c6.png";